import componentShell from "./shell"
import Signomatic from "@/signomatic/containers/signomatic"

export default componentShell(Signomatic)
